import { infiniteQueryOptions } from "@tanstack/react-query"
import type { WooCommerceProduct } from "@/services/woo-commerce-service"
import {
  DATA_FRESHNESS_MS,
  toReactQueryGcTime,
} from "@/utilities/data-freshness"

export interface CategoryProductsApiResponse {
  items: WooCommerceProduct[]
  page: number
  totalPages: number
  totalProducts: number
}

interface CategoryProductsPageLoaderInput {
  page: number
}

export type CategoryProductsPageLoader = (
  input: CategoryProductsPageLoaderInput
) => Promise<CategoryProductsApiResponse>

export const buildCategoryProductsQueryKey = (queryKeySeed: string) =>
  ["category-products", queryKeySeed] as const

export const getCategoryProductsInfiniteQueryOptions = ({
  onLoadMoreProducts,
  queryKeySeed,
}: {
  onLoadMoreProducts: CategoryProductsPageLoader
  queryKeySeed: string
}) =>
  infiniteQueryOptions({
    queryKey: buildCategoryProductsQueryKey(queryKeySeed),
    staleTime: DATA_FRESHNESS_MS.catalogList,
    gcTime: toReactQueryGcTime(DATA_FRESHNESS_MS.catalogList),
    initialPageParam: 1,
    queryFn: async ({ pageParam }: { pageParam: number }) =>
      onLoadMoreProducts({
        page: pageParam,
      }),
    getNextPageParam: (lastPage: CategoryProductsApiResponse) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
  })
